import { getCommissionType } from "../../../helpers";
import {
  IGetProgramBackEndModel,
  IStep1,
  IStep2,
  IStep3,
  IStep4,
} from "../types";
import { DATE_FORMATS, getDurationUnitsMap } from "../../../constants";
import moment from "moment";
import { getData } from "country-list";
import { currencies } from "../../../utils/const/currencies";
import { WizardMode } from "../../wizard/types";

const countries = getData();

export function parseToEditProgramInitialDataHigher(
  backEndData: IGetProgramBackEndModel,
) {
  const step1 = {} as IStep1;
  const step2 = {} as IStep2;
  const step3 = {} as IStep3;
  const step4 = {} as IStep4;

  step1.major = { id: backEndData.majorId, name: backEndData.majorName };
  // Program Type -------------------------------------------
  step1.programType = "" + backEndData.programType;

  // Program Duration -----------------------------------------------------
  step1.durationAmount = "" + backEndData.durationAmount;
  step1.durationUnit = {
    id: backEndData.durationUnit,
    name: getDurationUnitsMap("Program")[backEndData.durationUnit],
  };

  // Intakes --------------------------------------------------
  step1.existingIntakes = backEndData.intakes.map((intake) => ({
    deadline: moment(intake.deadline, DATE_FORMATS.frontEnd),
    startDate: moment(intake.startDate, DATE_FORMATS.frontEnd),
    isActive: intake.isActive,
    approved: String(intake?.applicationsCount?.approved),
    pending: String(intake?.applicationsCount?.pending),
  }));

  //  Branches ---------------------------------------------
  step1.branches = backEndData.branches.map((branch) => branch.branchId);
  step1.branchesWithAppCount = backEndData.branches.reduce((acc, branch) => {
    acc[branch.branchId] = branch;
    return acc;
  }, {});

  //  Exams ------------------------------------------------
  const addedExams = [...backEndData.exams];

  step2.mainExams = addedExams.splice(0, 3);
  addedExams.length && (step2.addedExams = addedExams);

  // Restricted Countries -----------------------------------------
  step2.restrictedCountries = backEndData.restrictedCountries.map(
    (country) => ({
      code: country,
      name: countries.find((c) => c.code === country)!.name,
    }),
  );

  // Tuition Duration -----------------------------------------------------
  step3.tuitionDurationAmount = backEndData.tuitionDurationAmount
    ? "" + backEndData.tuitionDurationAmount
    : "";
  step3.tuitionDurationUnit = {
    id: backEndData.tuitionDurationUnit,
    name: getDurationUnitsMap("Program")[backEndData.tuitionDurationUnit],
  };

  // Finance --------------------------------------------------
  step3.tuition = "" + backEndData.tuition;
  step3.currency = {
    id: backEndData.currency,
    name: currencies.find((c) => c.id === backEndData.currency)!.code,
  };
  step3.commissionAmount = "" + backEndData.commissionAmount;
  step3.commissionType = {
    id: backEndData.commissionType,
    name: getCommissionType(backEndData.commissionType),
  };

  const addedOtherFees = backEndData.otherFees.map((fee) => ({
    name: fee.name,
    amount: "" + fee.amount,
  }));

  step3.mainOtherFees = addedOtherFees.splice(0, 2);
  addedOtherFees.length && (step3.addedOtherFees = addedOtherFees);

  step3.hasTuitionScholarship = backEndData.hasTuitionScholarship;
  step3.hasTuitionFinancialAid = backEndData.hasTuitionFinancialAid;
  step3.hasOtherFeesScholarship = backEndData.hasOtherFeesScholarship;
  step3.hasOtherFeesFinancialAid = backEndData.hasOtherFeesFinancialAid;

  if (backEndData.tuitionScholarshipType !== null) {
    step3.tuitionScholarshipType = {
      id: backEndData.tuitionScholarshipType,
      name: getCommissionType(backEndData.tuitionScholarshipType),
    };
    step3.tuitionScholarshipAmount = "" + backEndData.tuitionScholarshipAmount;
  }

  if (backEndData.tuitionFinancialAidType !== null) {
    step3.tuitionFinancialAidType = {
      id: backEndData.tuitionFinancialAidType,
      name: getCommissionType(backEndData.tuitionFinancialAidType),
    };
    step3.tuitionFinancialAidAmount =
      "" + backEndData.tuitionFinancialAidAmount;
  }

  if (backEndData.otherFeesScholarshipType !== null) {
    step3.otherFeesScholarshipType = {
      id: backEndData.otherFeesScholarshipType,
      name: getCommissionType(backEndData.otherFeesScholarshipType),
    };
    step3.otherFeesScholarshipAmount =
      "" + backEndData.otherFeesScholarshipAmount;
  }

  if (backEndData.otherFeesFinancialAidType !== null) {
    step3.otherFeesFinancialAidType = {
      id: backEndData.otherFeesFinancialAidType,
      name: getCommissionType(backEndData.otherFeesFinancialAidType),
    };
    step3.otherFeesFinancialAidAmount =
      "" + backEndData.otherFeesFinancialAidAmount;
  }

  // Details --------------------------------------------------
  step4.details = {};

  backEndData.details.forEach((detail) => {
    step4.details[`type_${detail.type}`] = detail.content;
  });

  // Detail Files --------------------------------------------------
  step4.detailFiles = backEndData.detailFiles!.map((file) => ({
    id: file.fileId,
    name: file.name!,
    size: file.size!,
    path: file.path!,
  }));

  return {
    id: backEndData.id,
    academicId: backEndData.academicId,
    mode: WizardMode.Edit,
    step1,
    step2,
    step3,
    step4,
  };
}
